<template>
  <div class="box">
    <div class="boxFlex">
      <div class="boxTop">
        <div class="boxTopTex" :class="{act:isAct === 1}" @click="toPage('/home/zhszBanKuai/jbxxBanKuai')">基本信息</div>
        <div class="boxTopTex" :class="{act:isAct === 2}" @click="toPage('/home/zhszBanKuai/zhaqBanKuai')">账号安全</div>
      </div>
    </div>
    <div class="flexBox">
      <div class="boxBottom">
        <router-view @setAct="setAct"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "zhszBanKuai",
    data(){
      return {
        isAct:''
      }
    },
    computed: {


    },
    created() {
      this.$emit('setIsAct',8)

    },
    methods: {
      toPage(path){
        this.$router.push(path)
      },
      setAct(isAct){
        this.isAct = isAct
        console.log(this.isAct)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .act {
    color: #fff !important;
    background-color: #0089ff !important;
  }

  .box {
    width: 100%;
    .boxFlex {
      width: 100%;
      margin: 80px 0;
      display: flex;
      justify-content: center;
      .boxTop {
        width: 270px;
        display: flex;
        justify-content: space-between;
        .boxTopTex{
          width: 115px;
          height: 33px;
          border-radius: 17px;
          font-size: 18px;
          text-align: center;
          line-height: 33px;
          cursor: pointer;
          color: #ffffff;
        }
      }
    }
    .flexBox {
      width: 100%;
      display: flex;
      justify-content: center;
      .boxBottom {

      }
    }
  }


</style>